module.exports = __webpack_public_path__ + "fonts/Inter-Bold-slnt=0.3e3cb90.ttf";